export interface ITransferAccount {
  isAnonymous: boolean;
}

export interface ITransferAccountDatasource {
  account: ITransferAccount;
}

export class TransferConfiguration {

  private _datasource: ITransferAccountDatasource;

  constructor() {

  }

  configureAccount(account: ITransferAccountDatasource) {
    this._datasource = account;
  }

  get account() {
    return this._datasource;
  }

  isAnonymous() {
    return this._datasource.account.isAnonymous;
  }

  $get() {
    return this;
  }
}

angular.module('capability-ng-transfer')
  .provider('ngTransferConfiguration', TransferConfiguration);



// WEBPACK FOOTER //
// ./app/lib/transfer/config/transfer_configuration.ts